export default __webpack_public_path__ + "static/media/js.791bce2a.png";